import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const orderApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getOrder: builder.mutation({
      query: ({ body }) => ({
        url: `${END_POINTS.getOrders}`,
        method: "POST",
        body,
      }),
    }),

    deleteOrder: builder.mutation({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteOrders}${id}/`,
        method: "DELETE",
      }),
    }),

    updateOrderStatus: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.orderStatus}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    getOrderById: builder.query({
      query: ({ id }) => ({
        url: `${END_POINTS.getOrderById}${id}/`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetOrderMutation,
  useDeleteOrderMutation,
  useUpdateOrderStatusMutation,
  useLazyGetOrderByIdQuery,
} = orderApi;
